export default function KeyVal(props:{label:string,value:string,className?:string}) {
    const klass = "keyval" + (props.className ? " " + props.className : "")
    return <div className={klass}>
        <div className="label">{props.label}</div>
        <div className="value">{props.value}</div>
    </div>
}
